// Placeholder department names that mean "nobody put this person in a department".
// The name is lower-cased before it is compared, so every entry here is lower-case.
const PLACEHOLDER_NAMES = ["not assigned", "unassigned", "unknown", "-", "none", "null"];

export function hasNamedDepartment(employee = {}) {
  const name = String(employee.department_name || "").trim().toLowerCase();
  return Boolean(name) && !PLACEHOLDER_NAMES.includes(name);
}
